var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('span',[(_vm.user === null)?_c('router-link',{staticClass:"btn btn-warning",attrs:{"to":"/login"}},[_vm._v("Login")]):_vm._e(),(_vm.user !== null)?_c('span',{staticClass:"alert alert-success"},[_vm._v(_vm._s(_vm.user.firstName)+" "+_vm._s(_vm.user.lastName))]):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }